var map = {
	"./template-1/bundle/bundle": "app/styles/client/templates/template-1/bundle/bundle",
	"./template-10/bundle/bundle": "app/styles/client/templates/template-10/bundle/bundle",
	"./template-11/bundle/bundle": "app/styles/client/templates/template-11/bundle/bundle",
	"./template-2/bundle/bundle": "app/styles/client/templates/template-2/bundle/bundle",
	"./template-3/bundle/bundle": "app/styles/client/templates/template-3/bundle/bundle",
	"./template-4/bundle/bundle": "app/styles/client/templates/template-4/bundle/bundle",
	"./template-5/bundle/bundle": "app/styles/client/templates/template-5/bundle/bundle",
	"./template-6/bundle/bundle": "app/styles/client/templates/template-6/bundle/bundle",
	"./template-7/bundle/bundle": "app/styles/client/templates/template-7/bundle/bundle",
	"./template-8/bundle/bundle": "app/styles/client/templates/template-8/bundle/bundle",
	"./template-9/bundle/bundle": "app/styles/client/templates/template-9/bundle/bundle"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4823;